import { Reducer } from "redux";

import { AddTrainingVideoResponse } from "../models/api/Training";
import { AddTrainingVideoDispatchTypes } from "../models/dispatchTypes/Training";
import {
  defaultTrainingVideoResponse,
  PostTrainingVideoActionDispatchTypes,
} from "../constants/Training";

const initialState: AddTrainingVideoResponse = {
  loading: false,
  response: defaultTrainingVideoResponse,
  error: null,
};

const AddTrainingVideoReducer: Reducer<
  AddTrainingVideoResponse,
  AddTrainingVideoDispatchTypes
> = (state = initialState, action) => {
  switch (action.type) {
    case PostTrainingVideoActionDispatchTypes.POST_TRAINING_VIDEO_INVOKE: {
      return {
        ...state,
        loading: true,
      };
    }
    case PostTrainingVideoActionDispatchTypes.POST_TRAINING_VIDEO_SUCCESS: {
      return {
        ...state,
        response: action.response,
        loading: false,
      };
    }
    case PostTrainingVideoActionDispatchTypes.POST_TRAINING_VIDEO_ERROR: {
      return {
        ...state,
        error: action.error,
        loading: false,
      };
    }
    case PostTrainingVideoActionDispatchTypes.POST_TRAINING_VIDEO_RESET: {
      return initialState;
    }
  }
  return state;
};

export default AddTrainingVideoReducer;
